module.exports = __webpack_public_path__ + "img/fondo-login.68710430.jpg";